import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ApplicationTitle = () => {
  const { t } = useTranslation("questEditor");

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Box
        component="img"
        src="/kailog-talk_icon_512.png"
        alt={t("app.name")}
        sx={{
          width: 24,
          height: 24,
          objectFit: "contain",
        }}
      />
      <Typography variant="body2" color="text.secondary">
        {t("app.name")}
      </Typography>
    </Stack>
  );
};

export default ApplicationTitle;
